// Browser-side OTEL: emits spans for fetch calls and injects W3C
// `traceparent` on outgoing requests so downstream (traefik → canton)
// can link its work back to the user action that triggered it.
//
// Gate on hostname so the same built artifact is quiet in production
// (zero SDK init, zero POSTs) and active only in local dev.
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { WebTracerProvider, BatchSpanProcessor } from '@opentelemetry/sdk-trace-web';

// Hostnames where tracing is enabled. Extend as needed (staging, etc.).
const TRACED_HOSTNAMES = new Set(['tokenization.localhost']);

if (TRACED_HOSTNAMES.has(location.hostname)) {
  const provider = new WebTracerProvider({
    resource: { attributes: { 'service.name': 'frontend' } } as never,
    spanProcessors: [new BatchSpanProcessor(new OTLPTraceExporter({ url: '/v1/traces' }))],
  });

  provider.register();

  registerInstrumentations({
    // Default FetchInstrumentation injects traceparent on SAME-ORIGIN
    // requests only. Leaving cross-origin propagation off avoids CORS
    // preflight failures for OIDC redirects to external IDPs that don't
    // advertise `traceparent` in Access-Control-Allow-Headers.
    instrumentations: [new FetchInstrumentation()],
  });
}

export {};
